// src/pages/Dashboard.js
import React from 'react';

function Documents() {
    return <h1>Documents</h1>;
}

export default Documents;
